import React, { Fragment, useEffect } from 'react'
import './TechSupport.css'
import { Typography, Tab, Tabs, Button, Paper, Box } from '@mui/material'
import { GetApp } from '@mui/icons-material'
import TechSupportContactNA from '../components/TechSupportContactNA'
import TechSupportContactEU from '../components/TechSupportContactEU'
import { FormattedMessage, useIntl } from 'react-intl'
import SeoTechSupport from '../components/seo/SeoTechSupport'
import { useCookies } from 'react-cookie'
import BgImageTitleLayout from '../components/Common/BgImageTitleLayout'
import { TabsBox } from '../styles'

interface ITabPanel {
  children: React.ReactNode
  index: number
  value: number
}
function TabPanel(props: ITabPanel) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Fragment>{children}</Fragment>}
    </Typography>
  )
}

export default function TechSupport() {
  const intl = useIntl()
  const [value, setValue] = React.useState(0)
  const [cookies] = useCookies(['country_code'])

  useEffect(() => {
    setValue(cookies.country_code === 'us' ? 0 : 1)
  }, [cookies.country_code])

  return (
    <Box data-cy='techSupport-container'>
      <SeoTechSupport
        title={intl.formatMessage({ id: 'seo.support.title' })}
        description={intl.formatMessage({ id: 'seo.support.description' })}
      />
      <BgImageTitleLayout
        title='support.title'
        description='support.description'
        bgImage='url(https://meteor.stullercloud.com/das/138561691)'
      >
        <TabsBox sx={{ bgcolor: 'transparent !important' }}>
          <Tabs value={value} onChange={(_, newValue) => setValue(newValue)} aria-label='disabled tabs example'>
            <Tab disableRipple={true} label={<FormattedMessage id='nav.northAmerica' />} value={0} />
            <Tab disableRipple={true} label={<FormattedMessage id='nav.international' />} value={1} />
          </Tabs>
        </TabsBox>
        <TabPanel value={value} index={0}>
          <TechSupportContactNA />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TechSupportContactEU />
        </TabPanel>
        <Paper className='ts-paper' sx={{ bgcolor: '#333' }}>
          <Typography gutterBottom>
            <FormattedMessage id='support.downloadRemoteAssistance.description' />
          </Typography>
          <Button
            variant='outlined'
            size='small'
            startIcon={<GetApp />}
            color='secondary'
            href={
              window.navigator.userAgent.includes('Macintosh')
                ? 'https://gemvision.com/files/GemvisionSupportSOS.dmg'
                : 'https://gemvision.com/files/GemvisionSupportSOS.exe'
            }
          >
            <FormattedMessage id='support.downloadRemoteAssistance' />
          </Button>
        </Paper>
      </BgImageTitleLayout>
    </Box>
  )
}
